import { render } from "./OverlayPopup.vue?vue&type=template&id=c2ddf63a"
import script from "./OverlayPopup.vue?vue&type=script&lang=js"
export * from "./OverlayPopup.vue?vue&type=script&lang=js"
script.render = render

export default script